import { useNavigate } from "react-router-dom";
import userIcon from "../../../assets/general/carbon_user.svg";
import emailIcon from "../../../assets/general/carbon_email.svg";
import helpIcon from "../../../assets/general/carbon_help.svg";
import securityIcon from "../../../assets/general/carbon_security.svg";
import googlePlayIcon from "../../../assets/general/teenyicons_google-play-store-outline.svg";
import appleIcon from "../../../assets/general/la_apple.svg";
import { NavItem } from "../Header/NavItem";

interface SideNavProps {
  onContactUs?: () => void;
  onLegal?: () => void;
}

export function SideNav({ onContactUs, onLegal }: SideNavProps) {
  const navigate = useNavigate();

  function handleContactUs() {
    if (onContactUs) {
      onContactUs();
    } else {
      navigate("/");
    }
  }

  function handleLegal() {
    if (onLegal) {
      onLegal();
    } else {
      navigate("/terms-of-service");
    }
  }

  return (
    <div id="right-menu" className="container-header-right" style={{ zIndex: 100 }}>
      <div className="header-right">
        <div className="top-header-part">
      <NavItem
          icon={userIcon}
          label="Log In"
          className="login-button"
          href="https://web.360plusapp.com"
        />
          <NavItem
            icon={emailIcon}
            label="Contact Us"
            className="contactus-button contactus-icon"
            onClick={handleContactUs}
          />
          <NavItem icon={helpIcon} label="Support" className="support-button" />
          <NavItem
            icon={securityIcon}
            label="Legal"
            className="legal-button legal-icon"
            onClick={handleLegal}
          />
        </div>
        <div className="bottom-header-part">
          <div className="icon-container">
            <a
              href="http://play.google.com/store/apps/details?id=com.app360plus.mobile"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="header-icon" src={googlePlayIcon} alt="Google Play" />
            </a>
          </div>
          <div className="icon-container">
            <a
              href="https://apps.apple.com/us/app/360plus/id1571217336"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="header-icon" src={appleIcon} alt="App Store" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
